import { MultipleFileUploadComponent } from "components/form/MultipleFileUpload";
import { useState } from "react";
import { ReferralFormData } from "types";
const ReferralFormFields: React.FC<{
  formState: ReferralFormData;
  methods: { uu_id: string; name: string }[];
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void;
  isEditing: boolean;
  isEditMode: boolean;
  onCancelEdit: () => void;
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  uploadedFiles: File[];
}> = ({
  formState,
  methods,
  onChange,
  isEditing,
  isEditMode,
  onCancelEdit,
  uploadedFiles,
  setUploadedFiles,
}) => {
  const [showLetterInfo, setshowLetterInfo] = useState(false);

  return (
    <>
      <div className="grid grid-cols-2 gap-4 mt-4">
        <div className="flex flex-col">
          <label className="referral-form-label">Reception Method</label>
          <select
            className="referral-form-field"
            name="reception_method"
            value={formState.reception_method}
            onChange={onChange}
            disabled={!isEditing && isEditMode}
          >
            <option value="">Select Reception Method</option>
            {methods.map((method, index) => (
              <option key={index} value={method.uu_id}>
                {method.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label className="referral-form-label">Reception Date</label>
          <input
            type="date"
            className="referral-form-field"
            name="date"
            value={formState.date}
            onChange={onChange}
            disabled={!isEditing && isEditMode}
          />
        </div>
      </div>

      {formState.reception_method.toLowerCase() === "others" && (
        <div className="flex flex-col mt-4">
          <label className="referral-form-label">If Reception is Others</label>
          <input
            type="text"
            placeholder="Enter reception method"
            className="referral-form-field"
            name="reception_method_others"
            value={formState.reception_method_others}
            onChange={onChange}
            disabled={!isEditing && isEditMode}
          />
        </div>
      )}
      <div className="flex items-center mt-4">
        <input
          type="checkbox"
          id="showLetterInfo"
          checked={showLetterInfo}
          onChange={(e) => setshowLetterInfo(e.target.checked)}
          className="mr-2"
        />
        <label htmlFor="showLetterInfo" className="text-sm text-gray-700">
          Add Letter Information
        </label>
      </div>
      {showLetterInfo && (
        <>
          {" "}
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div className="flex flex-col">
              <label className="referral-form-label">Letter Information</label>
              <input
                type="text"
                placeholder="Enter letter information"
                className="referral-form-field"
                name="letter_info"
                value={formState.letter_info}
                onChange={onChange}
                disabled={!isEditing && isEditMode}
              />
            </div>

            {formState.letter_info.toLowerCase() === "organization" && (
              <div className="flex flex-col">
                <label className="referral-form-label">Letter Number</label>
                <input
                  type="text"
                  placeholder="Enter letter number"
                  className="referral-form-field"
                  name="letter_number"
                  value={formState.letter_number}
                  onChange={onChange}
                  disabled={!isEditing && isEditMode}
                />
              </div>
            )}
          </div>
          <MultipleFileUploadComponent
            onFilesChange={setUploadedFiles}
            uploadedFiles={uploadedFiles}
            label="Upload Letter Files"
            disabled={!isEditing && isEditMode}
          />
        </>
      )}

      <div className="flex flex-col mt-2">
        <label className="referral-form-label">Reception Office</label>
        <input
          type="text"
          placeholder="Enter reception office"
          className="referral-form-field"
          name="receiving_office"
          value={formState.receiving_office as string}
          onChange={onChange}
          disabled={!isEditing && isEditMode}
        />
      </div>

      <div className="flex flex-col mt-2">
        <label className="referral-form-label">Referral Summary</label>
        <textarea
          placeholder="Enter referral summary"
          className="referral-form-field"
          name="referal_summary"
          style={{ fontSize: "17x" }}
          value={formState.referal_summary as string}
          onChange={onChange}
          disabled={!isEditing && isEditMode}
        />
      </div>

      <div className="flex justify-end mt-6 gap-4">
        {isEditMode && isEditing && (
          <button
            type="button"
            onClick={onCancelEdit}
            className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
        )}
        <button
          type="submit"
          className="referral-form-button text-white"
          // disabled={isEditMode && !isEditing}
          onClick={() => console.log("referral register btn clicked")}
        >
          {isEditMode ? "Update" : "Register"}
        </button>
      </div>
    </>
  );
};

export default ReferralFormFields;
